<template>
  <section
    class="component-ea0617ff"
    resmed-component-name="multistep_2/3/4col_icon-line_graphic_text_cta"
    v-bind:style="{
      'background-image': `url(${acf.layout['background-image']})`,
      'background-color': acf.layout['background-color'],
      'padding-top': acf.layout['padding-top'],
      'padding-bottom': acf.layout['padding-bottom'],
    }"
  >
    <div
      class="component"
      v-bind:class="[`text-color-${acf.layout['text-color']}`]"
    >
      <div class="container px-xs-sm-2">
        <div class="row justify-content-center">
          <div class="col-md-10 text-center">
            <eyebrow-icon
              v-if="acf.eyebrowicon"
              v-bind:eyebrowicon="acf.eyebrowicon"
              v-bind:align="'center'"
            ></eyebrow-icon>
            <h2 v-if="acf.headline" v-html="acf.headline"></h2>
            <p v-if="acf.description" v-html="acf.description" class="mb-3"></p>

            <ul v-if="acf.items[0].tag" class="tags">
              <li v-for="item in acf.items" v-bind:class="[item.color]">
                {{ item.tag }}
              </li>
            </ul>
          </div>
        </div>
        <div
          class="items text-center"
          v-bind:class="[`length-${acf.items.length}`]"
        >
          <div class="item" v-for="item in acf.items">
            <figure
              v-bind:class="{
                'large-icon': item.function || acf.layout['large-icon'],
              }"
            >
              <img class="img-fluid" v-bind:src="`${item.icon}`" alt="" />
            </figure>

            <p v-if="item.function">
              <strong>{{ item.function }}</strong>
            </p>
            <h4 v-bind:class="[item.color]">{{ item.title }}</h4>
            <p class="content" v-html="item.description"></p>

            <div v-if="item.cta" class="call-to-action">
              <a
                v-if="item.cta[0]"
                v-bind:target="item.cta[0].cta.target"
                v-bind:href="item.cta[0].cta.href"
                class="btn cta-pill filled-red icon right-arrow"
                >{{ item.cta[0].cta.text }}</a
              >
              <a
                v-if="item.cta[1]"
                v-bind:target="item.cta[1].cta.target"
                v-bind:href="item.cta[1].cta.href"
                class="btn cta-pill hallow-red icon right-arrow"
                >{{ item.cta[1].cta.text }}</a
              >
            </div>
          </div>
        </div>
        <div class="text-center mt-5" v-if="acf.cta.href">
          <a
            v-bind:href="acf.cta.href"
            v-bind:target="acf.cta.target"
            class="btn cta-pill filled-red icon right-arrow"
            >{{ acf.cta.text }}</a
          >
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "component-ea0617ff", // multistep_2/3/4col_icon-line_graphic_text_cta
  props: ["acf"],
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.component-ea0617ff {
  padding: 6rem 0 5rem 0;
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
}

.component {
  &.text-color-white {
    h2 {
      &:before {
        background-color: $cc-resmed-white;
      }
    }

    p {
      color: $cc-resmed-white;
    }
  }

  h2 {
    position: relative;
    margin: 0 0 1rem 0;

    @extend %eyebrow-center;
  }

  h4 {
    margin-bottom: 0.5rem;

    &.black {
      color: $cc-resmed-black;
    }

    &.white {
      color: $cc-resmed-white;
    }

    &.red {
      color: $cc-resmed-action-red;
    }

    &.blue {
      color: $cc-resmed-hero-blue;
    }

    &.purple {
      color: $cc-resmed-sa-purple;
    }
  }

  ul {
    list-style: none;
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    margin-bottom: 1.5rem;

    li {
      position: relative;
      margin: 0 1.5rem;

      &:before {
        content: "";
        position: absolute;

        width: 0.65rem;
        height: 0.65rem;

        top: 50%;
        transform: translateY(-50%);
        left: -1.25rem;
        border-radius: 50%;
      }

      &.red {
        &:before {
          background-color: $cc-resmed-action-red;
        }
      }

      &.blue {
        &:before {
          background-color: $cc-resmed-hero-blue;
        }
      }

      &.white {
        &:before {
          background-color: $cc-resmed-white;
        }
      }
    }
  }

  .items {
    @media (min-width: 768px) {
      display: flex;
      justify-content: center;
    }

    &.length-2 {
      .item {
        @media (min-width: 768px) {
          width: 50%;
          max-width: 50%; // overwrite
        }

        @media (min-width: 992px) {
          max-width: 390px;
        }
      }
    }

    &.length-3 {
      .item {
        @media (min-width: 768px) {
          width: 33.3333%;
          max-width: 33.3333%; // overwrite
        }

        @media (min-width: 992px) {
          max-width: 360px;
        }
      }
    }

    &.length-4 {
      @media (min-width: 768px) and (max-width: 991px) {
        flex-wrap: wrap;

        .item {
          width: 50%;
          max-width: 50%; // overwrite
        }
      }

      @media (min-width: 992px) {
        .item {
          width: 25%;
          max-width: 25%; // overwrite
        }
      }
    }

    .item {
      padding: 2rem 0.625rem 1rem 0.625rem;
      margin: 0 auto;
      display: flex;
      flex-direction: column;

      @media (min-width: 768px) {
        max-width: 33.3333%;
      }

      @media (min-width: 992px) {
        margin: 0;
        padding: 2rem 2rem 1rem 2rem;
        max-width: 360px;
      }

      @media (min-width: 1200px) {
        min-width: 300px;
      }

      figure {
        display: flex;
        flex-direction: column;
        width: 100%;
        margin-bottom: 1rem;

        img {
          display: block;
          align-self: center;
          max-width: 3rem;
        }

        &.large-icon {
          img {
            max-width: 4.725rem;
          }
        }
      }

      .content {
        flex-grow: 1;
      }

      .call-to-action {
        @media (min-width: 768px) {
          min-height: 100px;
        }

        .btn {
          @media (min-width: 992px) {
            margin-left: 0.5rem;
            margin-right: 0.5rem;
          }

          &:last-child {
            margin-top: 0.75rem;
          }

          &:first-child {
            margin-top: 0;
          }
        }
      }
    }
  }
}
</style>